import get from 'lodash/get';
import * as companyAwardsActions from '../../action_creators/mic/company_awards_action_creators';
import CompanyAwardsModel from '../../../models/mic/company_awards_model';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import log from '../../../services/logger_service';

export default function fetchCompanyDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(companyAwardsActions.companyAwardsLoading({}, store));
    return CompanyAwardsModel.fetch(params, store)
      .then(function handleCompanyDetailData(CompanyData) {
        dispatch(
          companyAwardsActions.companyAwardsLoaded(CompanyData.data, store)
        );
      })
      .catch(function handleUserError(err) {
        const status = get(err, 'response.status.code') || 500;

        if (status === 404 || status === 401) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        }

        if (status === 500) {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(
            err,
            `Error in companyAwards actions, message: ${err.message}`
          );
        }

        dispatch(companyAwardsActions.companyAwardsLoadError(err, store));
      });
  };
}
